export enum SSOEntityId {
  EMW = 1,
  AllApp = 2,
  EasyBill = 3,
}
